import { render, staticRenderFns } from "./IftttForm.vue?vue&type=template&id=76800577&scoped=true"
import script from "./IftttForm.vue?vue&type=script&lang=js"
export * from "./IftttForm.vue?vue&type=script&lang=js"
import style0 from "./IftttForm.vue?vue&type=style&index=0&id=76800577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76800577",
  null
  
)

export default component.exports